import React from 'react'
import configureContext from '../configure-context'
import useCurrentUser from '../../../hooks/use-current-user'
import { uniq } from 'lodash'

const useConfigureDiscussion = ({
    topic,
    users = []
} = {}) => {
    const { id } = useCurrentUser()
    const { configureDiscussion } = React.useContext(configureContext)
    const showDiscussionConfiguration = React.useCallback(() => {
        configureDiscussion({ topic, users: uniq([...users, id ]) })
    }, [topic, users, configureDiscussion])
    return {
        showDiscussionConfiguration
    }
}

export default useConfigureDiscussion
